import { render } from "./CustomProgress.vue?vue&type=template&id=d422a350&scoped=true"
import script from "./CustomProgress.vue?vue&type=script&lang=js"
export * from "./CustomProgress.vue?vue&type=script&lang=js"

import "./CustomProgress.vue?vue&type=style&index=0&id=d422a350&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d422a350"]])

export default __exports__